var React = require('react');

function ShareLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M40 0H0V40H40V0ZM13.0532 17.0755H16.0312V26.6667H13.0532V17.0755ZM14.5479 12.3077C15.5 12.3077 16.2749 13.0838 16.2749 14.0374C16.2749 14.991 15.5 15.7671 14.5479 15.7671C13.5902 15.7671 12.8208 14.991 12.8208 14.0374C12.8208 13.0838 13.5902 12.3077 14.5479 12.3077ZM17.9079 17.0755H20.7531V18.3895H20.7919C21.1904 17.6355 22.1591 16.8427 23.6094 16.8427C26.6207 16.8427 27.1798 18.8274 27.1798 21.4109V26.6667H24.2072V22.0041C24.2072 20.8898 24.1906 19.4594 22.6628 19.4594C21.1129 19.4594 20.8804 20.6736 20.8804 21.921V26.6667H17.9079V17.0755Z","fill":"currentColor"}));
}

ShareLinkedin.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = ShareLinkedin;

ShareLinkedin.default = ShareLinkedin;
